import React from "react"
import Block from "@bappweb/block"
import Image from "@bappweb/image"
import "../assets/style.scss"
import Link from "@bappweb/link"
import { useAppSelector } from "../../../config/hook"
import { useDeviceSize, Sizes } from "@bappweb/provider"
import { getConfigValue } from "@smpu-web/utils/utils"

const LandingHeader = () => {
  let size = useDeviceSize()
  size = size === undefined ? Sizes.md : size
  const isHigherThanMd = size > Sizes.md ? true : false

  const sessionData = useAppSelector((state) => state.sessionData.response)

  return (
    <Block className="banner image-top">
      <Block className="container position-relative">
        <Link href="https://www.akbank.com/" className="logo">
          <Image className="logo" path={"./img/kredi-karti/logo.svg"} />
        </Link>
        <Block type="section" className="section general-features student-header-section header-text-container" dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, "CreditCard.LandingStudent.Top") }} />
        {isHigherThanMd &&
          <picture>
            <source
              data-srcset="./img/kredi-karti/ogrenci-kredi-karti.png, ./img/kredi-karti/ogrenci-kredi-karti.png@2x.png 2x"
              data-src="./img/kredi-karti/transparent.png"
            />
            <Image
              className="lazyload img-fluid banner-img ogr-image"
              path={"./img/kredi-karti/ogrenci-kredi-karti.png"}
            />
          </picture>
        }
      </Block>
    </Block>
  )
}

export default LandingHeader
